import React from 'react';
//import SubCategorias from './SubCategorias';
import firebase from './../Firestore'
import store from '../../store';

import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import TimeAgo from 'react-timeago'
import espanolStrings from 'react-timeago/lib/language-strings/es'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'

const formatter = buildFormatter(espanolStrings)

class MenuPrincipal extends React.Component {

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };

  _isMounted = false;
  _chequeadoPedidosPendientes = false;


  constructor(props) {
    super(props);
    const { cookies } = props;

    this.state = {
      carritoVacio: false,
      nroPedidoMasReciente:  cookies.get('nroPedidoMasReciente'),
      hayPedidoPendiente: store.getState().hayPedidoPendiente,
      hayPedidoPendienteFecha: ""
     };

     store.subscribe(() => {
       this.setState({
         hayPedidoPendiente: store.getState().hayPedidoPendiente,
       })
     });

  }

componentDidUpdate(prevState){
    //console.log("3")
    if(this._isMounted) {
      let currentComponent = this;
      if(this.state.carritoVacio !== prevState.carritoVacio){
        store.subscribe(() => {
          this.setState({
            carritoVacio: store.getState().carritoVacio
          })
        });
      }
      if(!currentComponent._chequeadoPedidosPendientes && this.state.nroPedidoMasReciente){
        this.hayPedidoPendiente();
      }
    }

}


hayPedidoPendiente(){

    let currentComponent = this;
    currentComponent._chequeadoPedidosPendientes = true;
    var db = firebase.firestore();
    var docRef = db.collection("pedido").doc(this.state.nroPedidoMasReciente);

    docRef.get().then(function(doc) {
        if (doc.exists) {
            //console.log("Document data:", doc.data());
            if (doc.data().enProceso){

              currentComponent.setState({hayPedidoPendiente: true})
              currentComponent.setState({hayPedidoPendienteFecha: Date.parse(doc.data().fecha.toDate())})
              //console.log("fecha", doc.data().fecha.toDate())
              return true
            } else {
              currentComponent.setState({hayPedidoPendiente: false})
              return false
            }
        } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
        }
    }).catch(function(error) {
        console.log("Error getting document:", error);
    });


}

componentDidMount() {
    this._isMounted = true;
    //console.log("1")
    if(this._isMounted) {
        if(this.state.nroPedidoMasReciente){
          this.hayPedidoPendiente()
        }
    }
  }



componentWillUnmount(){
  //console.log("en cat WillUnmount")
  this._isMounted = false;
  //store.unsubscribe(this);
}


verEstadoPedido(){
  store.dispatch({
    type: "ESTADO_PEDIDO",
    nroPedidoMasReciente: this.state.nroPedidoMasReciente
  });
}

onClick(event, diseno, catId) {
  //console.log("click del menu ppal", event.target.id, diseno, this.props.carritoVacio)
  store.dispatch({
    type: "LISTADO",
    catSeleccionadaMenuPrincipal: catId,
    diseno: diseno,
    carritoVacio: this.props.carritoVacio
  });
}



render() {

    const Items = this.props.cat.map((todo) =>
    <div className="text-center px-3 m-0" key={todo.id}>
      {todo.imagen ? (
      <img data-diseno={todo.diseno} src={todo.imagen} className="img-fluid rounded my-2 border" alt={todo.nombre} onClick={event => this.onClick(event, todo.diseno, todo.id)} />
      ) : (
      <button type="button" data-diseno={todo.diseno} className="btn btn-outline-warning btn-lg btn-block py-3 mx-auto my-2" style={{maxWidth: '400px'}} onClick={event => this.onClick(event, todo.diseno, todo.id)}><strong>{todo.nombre}</strong></button>
      )}
    </div>
    );


    return (
      <div className="bg-danger m-0 py-3 text-center" style={{minHeight:'500px'}}>

        {this.state.hayPedidoPendiente &&
          <button type="button" onClick={event => this.verEstadoPedido(event)} className="btn btn-primary my-2">
            Ver estado de tu pedido<br />
            <span className="badge badge-light">ingresado <TimeAgo date={this.state.hayPedidoPendienteFecha} formatter={formatter} /></span>
          </button>
        }

        {Items}
      </div>
    )
  }

}

export default withCookies(MenuPrincipal);
